export const insuranceType: { [key: number]: string } = {
  1: 'comprehensiveInsurance',
  2: 'comprehensiveInsuranceWithExcess',
  3: 'thirdPartyInsurance',
  4: 'extendedThirdPartyInsurance',
};
